
module.exports = {
    PROFILE_UPDATE_REQUEST: 'PROFILE_UPDATE_REQUEST',
    PROFILE_UPDATE_SUCCESS: 'PROFILE_UPDATE_SUCCESS',
    PROFILE_UPDATE_FAILURE: 'PROFILE_UPDATE_FAILURE',
    VALIDATION_PROFILE_ERROR: 'VALIDATION_PROFILE_ERROR',
    CLEAR_PROFILE_ERROR: 'CLEAR_PROFILE_ERROR',
    SET_PROFILE_SUCCESS: 'SET_PROFILE_SUCCESS',
    CLEAR_PROFILE_SUCCESS: 'CLEAR_PROFILE_SUCCESS',
    INTERESTED_IN_CLINICAL_TRIALS_SUCCESS: 'INTERESTED_IN_CLINICAL_TRIALS_SUCCESS',
    SET_POSTAL_CODE_ERROR: 'SET_POSTAL_CODE_ERROR',
    CLEAR_POSTAL_CODE_ERROR: 'CLEAR_POSTAL_CODE_ERROR',
    SAVE_PROFILE_POSTAL_CODE_SUCCESS: 'SAVE_PROFILE_POSTAL_CODE_SUCCESS'
};



// WEBPACK FOOTER //
// ./src/common/modules/profile/constants.js